/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CopyWithExceptionIconOutline = createIcon({
  displayName: 'CopyWithExceptionIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15 21h-11c-.552 0-1-.448-1-1v-11c0-.552.448-1 1-1h11c.552 0 1 .448 1 1v11c0 .552-.448 1-1 1Z"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 5v-1c0-.552-.448-1-1-1h-1"></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 15v1c0 .552-.448 1-1 1h-1"></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M7 5v-1c0-.552.448-1 1-1h1"></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 3h2"></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 11v-2 0 0Z"></path>
      </g>
    </>
  ),
})

const CopyWithException: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={CopyWithExceptionIconOutline} {...props} />
  }
}

export default memo(CopyWithException)
